import { Tag, Tooltip, Typography } from 'antd';

const { Text } = Typography;

/**
 * Renders source citation chips beneath an assistant message. Each chip is
 * prefixed with its [n] passage number (matching the inline markers in the
 * answer). Clicking opens the source document with the cited passage
 * highlighted; hovering previews the snippet.
 */
export default function CitationChips({ label, citations, onOpenSource }) {
  if (!citations || citations.length === 0) return null;

  return (
    <div style={{ marginTop: 6 }}>
      <Text type="secondary" style={{ fontSize: 12, marginRight: 6 }}>
        {label}:
      </Text>
      <span className="inline-flex flex-wrap gap-1">
        {citations.map((citation, index) => {
          const clickable = !!citation.documentId;
          return (
            <Tooltip
              key={citation.chunkId || citation.documentId || index}
              title={citation.snippet || ''}
            >
              <Tag
                onClick={
                  clickable && onOpenSource
                    ? () => onOpenSource(citation)
                    : undefined
                }
                style={{
                  marginInlineEnd: 0,
                  maxWidth: 260,
                  cursor: clickable ? 'pointer' : 'default',
                }}
              >
                {citation.marker != null && (
                  <b style={{ marginRight: 4 }}>[{citation.marker}]</b>
                )}
                <span
                  style={{
                    display: 'inline-block',
                    maxWidth: 200,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'bottom',
                  }}
                >
                  {citation.title}
                </span>
              </Tag>
            </Tooltip>
          );
        })}
      </span>
    </div>
  );
}
